<template>
  <div class="d-flex" style="gap: 20px">
    <v-card outlined>
      <v-card-text class="text-caption pb-0">
        <span style="background-color: white">
          {{ $t('newPackage.viewingPeriod.startAt') }}
        </span>
      </v-card-text>
      <v-container class="pb-6">
        <v-container class="d-flex" style="gap: 20px">
          <DateTimePicker
            :date="startDate"
            :time="startTime"
            icon="mdi-calendar"
            :dateLabel="String($t('newPackage.viewingPeriod.date'))"
            :timeLabel="String($t('newPackage.viewingPeriod.time'))"
            :hasPeriodError="!!errorMessage"
            @update:date="$emit('update:startDate', $event)"
            @update:time="$emit('update:startTime', $event)"
            @validate-period="$emit('validate')"
          />
        </v-container>
      </v-container>
    </v-card>

    <v-card outlined>
      <v-card-text class="text-caption pb-0">
        <span style="background-color: white">
          {{ $t('newPackage.viewingPeriod.endAt') }}
        </span>
      </v-card-text>
      <v-container class="pb-6">
        <v-container class="d-flex" style="gap: 20px">
          <DateTimePicker
            :date="endDate"
            :time="endTime"
            icon="mdi-calendar"
            :dateLabel="String($t('newPackage.viewingPeriod.date'))"
            :timeLabel="String($t('newPackage.viewingPeriod.time'))"
            :hasPeriodError="!!errorMessage"
            @update:date="$emit('update:endDate', $event)"
            @update:time="$emit('update:endTime', $event)"
            @validate-period="$emit('validate')"
          />
        </v-container>
        <span class="error--text text-caption">{{ errorMessage }}</span>
      </v-container>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "@vue/composition-api";
import DateTimePicker from "./DateTimePicker.vue";

export default defineComponent({
  name: "PackageViewingPeriod",
  components: { DateTimePicker },
  props: {
    startDate: { type: String as PropType<string | null>, default: null },
    startTime: { type: String, default: "" },
    endDate: { type: String as PropType<string | null>, default: null },
    endTime: { type: String, default: "" },
    errorMessage: { type: String, default: "" },
  },
});
</script>
